// Custom components
import React from "react";
import { BsEyeSlashFill } from "react-icons/bs";

function InputField(props: {
  id: string;
  label?: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  type?: string;
  ispassword?: boolean;
  required?: boolean;
}) {
  const { label, id, extra, type, placeholder, variant, state, disabled, required, ispassword } = props;

  return (
    <div className={`${extra}`}>
      {
        label ? <label
          htmlFor={id}
          className={`text-small text-gray-800 dark:text-gray-300 ${
            variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
          }`}
        >
          {label}
          {required ? <span className="text-[#ff0000]">*</span> : <></>}
        </label> : <></>
      }
      <div className="relative">
        <input
          disabled={disabled}
          type={type}
          id={id}
          placeholder={placeholder}
          className={`mt-1 flex w-full items-center justify-center rounded-[6px] border bg-white dark:bg-gray-900 pl-3 py-2 pr-10 text-sm outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : state === "error"
              ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : state === "success"
              ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : "border-gray-200 dark:!border-white/10 dark:text-white"
          }`}
        />
        { ispassword ? <span className="absolute top-1.5 right-3 text-large text-gray-700"><BsEyeSlashFill /></span> : <></> }
      </div>
    </div>
  );
}

export default InputField;
